import { defineComponent as _defineComponent } from 'vue'
import type { CloseEndedQuestion } from '@ilteducation/exercise-service-types';
import { ref } from 'vue';
import ArrayInput from '@/components/base/ArrayInput.vue';

type Props = {
  index: number;
  parentSource: string;
  resource: string;
  item: CloseEndedQuestion;
  preview: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CloseEndedQuestion',
  props: {
    index: null,
    parentSource: null,
    resource: null,
    item: null,
    preview: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  index: number;
  parentSource: string;
  resource: string;
  item: CloseEndedQuestion;
  preview: boolean;
}



const model = ref(props.item);

return { __sfc: true,props, model, ArrayInput }
}

})